import axios from "axios";
import { getCookie } from "../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;
const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  Authorization: getCookie("mawalog"),
};
export async function getButtonApi() {
  const res = await axios.get(`${apiUrl}quick_report`, { headers: header });
  return res.data;
}

export async function getDatesApi(selectedButton, startDate, endDate) {
  if (!selectedButton) throw new Error("No button selected");

  const from = startDate ? startDate.toLocaleDateString("en-CA") : "";
  const to = endDate ? endDate.toLocaleDateString("en-CA") : "";

  const res = await axios.get(
    `${apiUrl}report/${selectedButton}?from_date=${from}&to_date=${to}`,
    { headers: header }
  );

  return res;
}

export async function getExportApi(
  selectVehicleType,
  selectVehicle,
  selectDriver,
  selectStatus,
  selectUser,
  startDate,
  endDate
) {
  try {
    const params = new URLSearchParams({
      vehicle_type: selectVehicleType?.value || "",
      vehicle_id: selectVehicle?.value || "",
      driver_id: selectDriver?.value || "",
      status: selectStatus?.value || "",
      user_id: selectUser?.value || "",
      //   from_date: startDate ? startDate.toISOString().slice(0, 10) : "",
      //   to_date: endDate ? endDate.toISOString().slice(0, 10) : "",
    });

    const response = await axios.get(
      `${apiUrl}report/customized_report?${params.toString()}`,
      { headers: header }
    );
    return response;
  } catch (err) {
    console.error("Export error:", err);
    throw err;
  }
}

export const downloadBase64File = (base64String, fileName) => {
  const binary = atob(base64String);
  const array = [];

  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  const blob = new Blob([new Uint8Array(array)], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
